// BubbleLoader.jsx
import React from 'react';
import { withStyles } from '@mui/styles';

const styles = {
  loaderBox: {
    position: 'relative',
    display: 'inline-block',
    margin: 0,
    width: '16px',
    height: '16px',
  },
  bubble: {
    position: 'absolute',
    top: '50%',
    left: 0,
    transform: 'translate(-50%, -50%)',
    right: 0,
    margin: '0 auto',
    content: '""',
    width: '3px',
    height: '3px',
    borderRadius: '50%',
    background: 'green',
    opacity: 0,
  },
  animate: {
    animation: '$bubbleEffect 3s ease-out infinite',
    opacity: 1,
  },
  delay2: {
    animationDelay: '1.5s',
  },
  '@keyframes bubbleEffect': {
    '0%': {
      opacity: 1,
    },
    '100%': {
      transform: 'scale(5)',
      opacity: 0,
    },
  },
};

const BubbleLoader = ({ classes }) => {
  return (
    <div className={classes.loaderBox}>
      <div className={classes.bubble}></div>
      <div className={`${classes.bubble} ${classes.animate}`}></div>
      <div className={`${classes.bubble} ${classes.animate} ${classes.delay2}`}></div>
    </div>
  );
};

export default withStyles(styles)(BubbleLoader);
